import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthCoverLoginComponent } from './auth/auth-cover-login/auth-cover-login.component';

import { AuthRePasswordThreeComponent } from './auth/auth-re-password-three/auth-re-password-three.component';
import { AuthSignupThreeComponent } from './auth/auth-signup-three/auth-signup-three.component';

import { AccountMembersComponent } from './core/components/account-members/account-members.component';
import { AccountMessagesComponent } from './core/components/account-messages/account-messages.component';
import { AccountProfileComponent } from './core/components/account-profile/account-profile.component';
import { AccountSettingComponent } from './core/components/account-setting/account-setting.component';
import { AccountWorksComponent } from './core/components/account-works/account-works.component';
import { ComponentsComponent } from './core/components/components/components.component';


import { IndexHotelComponent } from './core/components/index-hotel/index-hotel.component';
import { IndexTravelComponent } from './core/components/index-travel/index-travel.component';
import { MasterPageComponent } from './core/components/master-page/master-page.component';
import { PageAboutusComponent } from './core/components/page-aboutus/page-aboutus.component';
import { PageBlogDetailComponent } from './core/components/page-blog-detail/page-blog-detail.component';

import { PageComingsoonComponent } from './core/components/page-comingsoon/page-comingsoon.component';

import { PageContactTwoComponent } from './core/components/page-contact-two/page-contact-two.component';

import { PageHistoryComponent } from './core/components/page-history/page-history.component';

import { PagePrivacyComponent } from './core/components/page-privacy/page-privacy.component';
import { PageServicesComponent } from './core/components/page-services/page-services.component';
import { PageTermsComponent } from './core/components/page-terms/page-terms.component';

import { EmailAlertComponent } from './email/email-alert/email-alert.component';
import { EmailConfirmationComponent } from './email/email-confirmation/email-confirmation.component';
import { EmailInvoiceComponent } from './email/email-invoice/email-invoice.component';
import { EmailPasswordResetComponent } from './email/email-password-reset/email-password-reset.component';
import { SwitcherComponent } from './shared/switcher/switcher.component';

import { combineLatest } from 'rxjs/operators';



import { BlogAboutComponent } from './core/components/blog-about/blog-about.component';





import { AccountChatComponent } from './core/components/account-chat/account-chat.component';
import { IndexBlogComponent } from './core/components/index-blog/index-blog.component';
import { EventsComponent } from './shared/Blimb/MasterData/events/events.component';
import { EventDetailsComponent } from './shared/Blimb/MasterData/event-details/event-details.component';
import { CountryEventsComponent } from './shared/Blimb/MasterData/country-events/country-events.component';
import { EventDetailsInCountryComponent } from './shared/Blimb/MasterData/event-details-in-country/event-details-in-country.component';
import { AddCommentComponent } from './shared/Blimb/Evaluations/add-comment/add-comment.component';
import { AllExperiencesComponent } from './Experiences/components/all-experiences/all-experiences.component';
import { AllcampsComponent } from './shared/Blimb/Camping/allcamps/allcamps.component';
import { CampsDetailsComponent } from './shared/Blimb/Camping/camps-details/camps-details.component';
import { ExperiencesByTravelerComponent } from './Experiences/components/experiences-by-traveler/experiences-by-traveler.component';
import { MyExperincesComponent } from './Experiences/components/my-experinces/my-experinces.component';
import { AllFoodsComponent } from './shared/Blimb/Foods/all-foods/all-foods.component';
import { FoodDetailsComponent } from './shared/Blimb/Foods/food-details/food-details.component';
import { AllAdventuresComponent } from './shared/Blimb/Adventures/all-adventures/all-adventures.component';
import { AdventureDeleailsComponent } from './shared/Blimb/Adventures/adventure-deleails/adventure-deleails.component';
import { AllSouvenirsComponent } from './shared/Blimb/Souvenirs/all-souvenirs/all-souvenirs.component';
import { SouvenirDetailsComponent } from './shared/Blimb/Souvenirs/souvenir-details/souvenir-details.component';
import { AllVisasComponent } from './shared/Blimb/Visas/all-visas/all-visas.component';
import { VisaDetailsComponent } from './shared/Blimb/Visas/visa-details/visa-details.component';
const routes: Routes = [
  {
    path: '',
    component: MasterPageComponent,
    children: [
      { path: '', component: IndexHotelComponent },
      { path: 'Home-three', component: IndexTravelComponent },
      { path: 'Home-two', component: PageContactTwoComponent },
      { path: 'index-hotel', component: IndexHotelComponent },

      { path: 'account-messages', component: AccountMessagesComponent },
      { path: 'account-members', component: AccountMembersComponent },
      { path: 'account-profile', component: AccountProfileComponent },
      { path: 'account-setting', component: AccountSettingComponent },
      { path: 'account-works', component: AccountWorksComponent },
      { path: 'account-chat', component: AccountChatComponent },
      { path: 'blog', component: IndexBlogComponent },

      { path: 'components', component: ComponentsComponent },
      { path: 'page-aboutus', component: PageAboutusComponent },
      { path: 'page-blog-detail', component: PageBlogDetailComponent },
      { path: 'page-history', component: PageHistoryComponent },
      { path: 'page-privacy', component: PagePrivacyComponent },
      { path: 'page-services', component: PageServicesComponent },
      { path: 'page-terms', component: PageTermsComponent },
      { path: '#', component: SwitcherComponent },
      { path: 'blog-about', component:  BlogAboutComponent},

      { path: 'foods', component:  AllFoodsComponent},
      { path: 'food-details/:id', component:  FoodDetailsComponent},
      { path: 'adventures', component:  AllAdventuresComponent},
      { path: 'adventures-details/:id', component:  AdventureDeleailsComponent},
      { path: 'souvenirs', component:  AllSouvenirsComponent},
      { path: 'souvenirs-details/:id', component:  SouvenirDetailsComponent},
      { path: 'visas', component:  AllVisasComponent},
      { path: 'visa-details/:id', component:  VisaDetailsComponent},
    ]
  },


  { path: 'login', component: AuthCoverLoginComponent },
  { path: 'repassword', component: AuthRePasswordThreeComponent },
  { path: 'signup', component: AuthSignupThreeComponent },
  { path: 'comingsoon', component: PageComingsoonComponent },
  { path: 'email-alert', component: EmailAlertComponent },
  { path: 'email-confirmation', component: EmailConfirmationComponent },
  { path: 'email-invoice', component: EmailInvoiceComponent },
  { path: 'email-password-reset', component: EmailPasswordResetComponent },
  { path: 'events-world', component:  EventsComponent},
  { path: 'events-Details/:id', component:  EventDetailsComponent},
  { path: 'country-events/:id', component:  CountryEventsComponent},
  { path: 'country-event-details/:id', component:  EventDetailsInCountryComponent},
  { path: 'event-comment/:id', component:  AddCommentComponent},
  {path: 'experiences', component:AllExperiencesComponent},
  {path: 'my-experiences', component:MyExperincesComponent},
  {path: 'experiences-for-traveler/:id', component:ExperiencesByTravelerComponent},
  
  
  { path: 'camps', component:  AllcampsComponent},
  { path: 'camps-details/:id', component:  CampsDetailsComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: "top",
  scrollOffset: [0, 0],
  // Enable scrolling to anchors
  anchorScrolling: "enabled"})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
